import moment from "moment/moment";
import store from "../../store/index";

const isHOM = store.getters["app/isHOM"];
const isAndroid = store.getters["app/isAndroid"];
const isIOS = store.getters["app/isIOS"];


export default class remind {
  //添加日历提醒
  static addCalendar(timeDatas, remindData, freq) {
    let data = { webAction: "addCalendar", calendarData: [] };
    let list = [
      "坚持用药，防微杜渐",
      "用药时间到啦，别忘了哈",
      "为了自己也为了家人，要按时用药哦"
    ];

    let remindTime = "";
    if (remindData.remindTime) {
      remindTime = remindData.remindTime;
    } else {
      remindTime = moment(new Date()).format("YYYY-MM-DD");
    }
    for (var i in timeDatas) {
      //迭代服用时间
      data.calendarData.push({
        //组装日历提醒数据
        year: remindTime.split("-")[0],
        month: remindTime.split("-")[1],
        day: remindTime.split("-")[2],
        hourOfDay: timeDatas[i].split(":")[0], //时
        minute: timeDatas[i].split(":")[1], //分
        dosageData: remindData.dose + remindData.unit, //剂量+单位
        drugName: remindData.medicineName, //用药名称
        description: list[Math.floor(Math.random() * 3)], //随机一句话
        expirationDate: remindData.expirationDate, //过期时间
        id: "-1"
      });

      if (freq) {
        data.calendarData[i]["freq"] = freq;
      }
    }
    return data;
  }

  static addCalendar2(timeDatas, remindDate, otherData, freq) {
    let data = { webAction: "addCalendar", calendarData: [] };
    let list = [
      "坚持复诊，防微杜渐",
      "复诊时间到啦，别忘了哈",
      "为了自己也为了家人，要按时复诊哦"
    ];
    if (remindDate) {
      remindDate = moment(remindDate).format("YYYY-MM-DD");
    } else {
      remindDate = moment(new Date()).format("YYYY-MM-DD");
    }
    for (var i in timeDatas) {
      //迭代服用时间
      data.calendarData.push({
        //组装日历提醒数据
        year: remindDate.split("-")[0],
        month: remindDate.split("-")[1],
        day: remindDate.split("-")[2],
        hourOfDay: timeDatas[i].split(":")[0], //时
        minute: timeDatas[i].split(":")[1], //分
        description: list[Math.floor(Math.random() * 3)], //随机一句话
        // dosageData: remindData.dose + remindData.unit, //剂量+单位
        // drugName: remindData.medicineName, //用药名称
        // expirationDate: remindData.expirationDate, //过期时间
        id: "-1"
      });
      data.calendarData[i] = Object.assign(data.calendarData[i], otherData);
      if (freq) {
        data.calendarData[i]["freq"] = freq;
      }
    }
    console.log(JSON.stringify(data.calendarData));
    if (window.addCalendar && window.addCalendar.call) {
      const result = window.addCalendar.call(JSON.stringify(data)); //添加日历
      console.log(result);
    }
    return new Promise(resolve => {
      //返回结果
      window.addCalendarResult = list => {
        if (list != "error") {
          resolve(list);
        } else {
          this.utils.ToastSuccess("日历添加失败");
        }
      };
    });
  }

  static addSystemReminder(timeDatas, remindDate, description) {
    console.log(JSON.stringify("addSystemReminder" + timeDatas));
    let  model = localStorage.getItem('phoneModel')
    let _data = {
      webAction: "addSystemReminder",
      data: []
    };
    for (var i in timeDatas) {
      let remindDate = otherData.remindTime
        ? otherData.remindTime + " " + timeDatas[i]
        : moment().format("YYYY-MM-DD") + " " + timeDatas[i];
      console.log(remindDate);
      let obj = {};
      if (model == 'IOS') {
        obj = this.getTime2(remindDate);
      } else {
        obj = this.getTime(remindDate);
      }
      //迭代服用时间
      _data.data.push({
        //组装日历提醒数据
        hourOfDay: timeDatas[i].split(":")[0], //时
        minute: timeDatas[i].split(":")[1], //秒
        description: description,
        // this.reminderData.medicineName +
        // ":" +
        // this.reminderData.dose +
        // this.reminderData.unit,
        slotId: "BluePill",
        id: "-1",
        //以下兼容ios和android
        year: obj.year,
        month: obj.month,
        day: obj.day,
        hour: obj.hour,
        date: obj.day
      });
      if (remindDate) {
        _data.data[i].months = [remindDate.split("-")[0]];
        _data.data[i].days = [remindDate.split("-")[1]];
      }
    }
    if (window.addSystemReminder && window.addSystemReminder.call) {
      //
      const result = window.addSystemReminder.call(JSON.stringify(_data)); //添加本地提醒
      console.log(result);
    }
    return new Promise(resolve => {
      //返回结果
      window.addSystemReminderResult = list => {
        if (list != "error") {
          let data = JSON.parse(list);
          // if (data.length > 0) {
          //   //this.reminderData.localhostId = ''
          //   this.reminderData.localhostId = this.splitCalendarList(
          //     data,
          //     "reminderId"
          //   ); //本地提醒ID
          // }
          // this.remindersCount++;
          resolve(list);
        } else {
          this.utils.ToastSuccess("应用提醒最多只能创建30条，创建失败！");
        }
      };
    });
  }

  static getAlarmData(timeDatas, description) {
    let data = {
      webAction: "addAlarm",
      alarmData: []
    };
    for (var i in timeDatas) {
      //迭代服用时间
      data.alarmData.push({
        //组装日历提醒数据
        hourOfDay: timeDatas[i].split(":")[0],
        minute: timeDatas[i].split(":")[1],
        description: description,

        weeks: [1, 2, 3, 4, 5, 6, 7]
      });
    }
    return data;
  }

  static deleteSystemReminder(localhostId) {
    //删除本地提醒
    if (window.deleteSystemReminder && window.deleteSystemReminder.call) {
      //
      const result = window.deleteSystemReminder.call(
        `{"webAction":"deleteSystemReminder","id":"[${localhostId}]"}`
      ); //删除本地提醒
    }
  }

  static getTime(date) {
    let obj = {
      year: moment(date).format("YYYY"),
      month: moment(date).format("MM"),
      day: moment(date).format("DD"),
      hour: moment(date).format("HH"),
      minute: moment(date).format("mm"),
      endMinute: moment(date)
        .add(1, "m")
        .format("mm")
    };

    return obj;
  }

  static getTime2(date) {
    let obj = {
      year: moment(date).year(),
      month: moment(date).month() + 1,
      day: moment(date).date(),
      hour: moment(date).hour(),
      minute: moment(date).minute(),
      endMinute: moment(date).minute() + 1
    };
    return obj;
  }

  static getCalendarData(timeDatas, otherData, freq, rule) {
    let model = localStorage.getItem('phoneModel')
    let data = { webAction: "addCalendar", calendarData: [] };
    let list = [
      "坚持用药，防微杜渐",
      "用药时间到啦，别忘了哈",
      "为了自己也为了家人，要按时用药哦"
    ];
    for (var i in timeDatas) {
      let remindDate = otherData.remindTime
        ? otherData.remindTime + " " + timeDatas[i]
        : moment().format("YYYY-MM-DD") + " " + timeDatas[i];
      let obj = {};
      if (model == 'IOS') {
        obj = this.getTime2(remindDate.replace(/-/g, "/"));
      } else {
        obj = this.getTime(remindDate.replace(/-/g, "/"));
      }

      //迭代服用时间
      data.calendarData.push({
        //组装日历提醒数据
        year: obj.year,
        month: obj.month,
        day: obj.day,
        hourOfDay: obj.hour, //时
        minute: obj.minute, //分
        description: list[Math.floor(Math.random() * 3)], //随机一句话
        id: "-1",

        //以下兼容ios，android
        startYear: obj.year, //开始时间年
        startMonth: obj.month, //开始月份
        startDate: obj.day, //开始日
        startHourOfDay: obj.hour, //开始时
        startMinute: obj.minute,
        endYear: obj.year, //结束时间年
        endMonth: obj.month, //结束月份
        endDate: obj.day, //结束日
        endHourOfDay: obj.hour, //结束时
        endMinute: obj.endMinute, //结束分
        RemindersMinutes: 0
      });
      data.calendarData[i] = Object.assign(data.calendarData[i], otherData);
      if (freq) {
        data.calendarData[i]["freq"] = freq;
      }
      if (rule) {
        data.calendarData[i]["rule"] = rule;
      }
    }
    return data;
  }

  static getSystemReminderData(timeDatas, otherData, freq,rule) {
    let model = localStorage.getItem('phoneModel')
    let _data = {}
    if(model == 'HOM'){
      _data = {
        webAction: "addSystemReminder",
        data: []
      };
    }else {
      _data = {
        webAction: "addNotification",
        data: []
      };
    }
    for (var i in timeDatas) {
      let remindDate = otherData.remindTime
        ? otherData.remindTime + " " + timeDatas[i]
        : moment().format("YYYY-MM-DD") + " " + timeDatas[i];
      let obj = {};
      if (model == 'IOS') {
        obj = this.getTime2(remindDate);
      } else {
        obj = this.getTime(remindDate);
      }
      if(model == 'IOS'){
        _data.data.push({
          //组装日历提醒数据
          year: obj.year,
          month: obj.month,
          day: obj.day,
          hourOfDay: obj.hour, //时
          minute: obj.minute, //分
          description: otherData.description, //随机一句话
          id: "-1",
          //以下兼容ios，android
          startYear: obj.year, //开始时间年
          startMonth: obj.month, //开始月份
          startDate: obj.day, //开始日
          startHourOfDay: obj.hour, //开始时
          startMinute: obj.minute,
          endYear: obj.year, //结束时间年
          endMonth: obj.month, //结束月份
          endDate: obj.day, //结束日
          endHourOfDay: obj.hour, //结束时
          endMinute: obj.endMinute, //结束分
          RemindersMinutes: 0
        })
      }else {
        //迭代服用时间
        _data.data.push({
          //组装本地提醒数据
          hourOfDay: obj.hour, //时
          minute: obj.minute, //秒
          description: otherData.description,
          slotId: "BluePill",
          id: "-1",
          //以下兼容ios和android
          year: obj.year,
          month: obj.month,
          day: obj.day,
          hour: obj.hour,
          date: obj.day
        });
      }
      _data.data[i] = Object.assign(_data.data[i], otherData);
      //有freq则为重复，无则为单次
      if (!freq) {
        _data.data[i].months = [obj.month];
        _data.data[i].days = [obj.day];
      } else {
        _data.data[i]["freq"] = freq;
      }
      if (rule) {
        _data.data[i]["rule"] = rule;
      }
    }
    return _data;
  }

  static getAlarmData(timeDatas, description) {
    let data = {
      webAction: "addAlarm",
      alarmData: []
    };
    for (var i in timeDatas) {
      //迭代服用时间
      data.alarmData.push({
        //组装日历提醒数据
        hourOfDay: timeDatas[i].split(":")[0],
        minute: timeDatas[i].split(":")[1],
        description: description,

        weeks: [1, 2, 3, 4, 5, 6, 7]
      });
    }
    return data;
  }

  static getDeleteSystemReminderData(localhostIds) {
    let model = localStorage.getItem('phoneModel')
    let data = {
      webAction: "deleteSystemReminder"
    };
    if(model == 'HOM'){
      if(localhostIds.indexOf(",") == -1){
        data.id = [localhostIds]
      }else {
        data.id = localhostIds.split(",")
      }
    }else if(model == 'IOS') {
      data.webAction = "deleteNotification"
      data.localhostIds = localhostIds.split(",");
    } else {
      data.id = localhostIds.split(",");
    }
    return data;
  }

  static getDeleteCalendarData(calenderIds) {
    let model = localStorage.getItem('phoneModel')
    let data = {
      webAction: "deleteCalendar"
    };
    if (model == 'HOM') {
      data.calendarIds = calenderIds.split(",");
    } else if (model == 'IOS') {
      data.calendarIds = calenderIds.split(",");
    } else {
      data.calendarId = calenderIds.split(",");
    }

    return data;
  }

  static splitCalendarList(list, id) {
    let arr = [];
    // if (isHOM) {
    //   list = JSON.parse(list);
    // }
    list.forEach(item => {
      arr.push(item[id]);
    });

    return arr.toString();
  }
}



// WEBPACK FOOTER //
// ./src/components/utils/remind.js